export default __webpack_public_path__ + "static/205-1f714a7ae87279f2ed18d8ed73567d06.jpg";